import React from "react";
import DataSection from "../components/sections/Data.jsx";
import { data } from "../constants/onedio/data.js";
import { socialMediaSlides } from "../constants/onedio/socialMediaSlides.js";
import { icerikler } from "../constants/onedio/icerikler.js";
import { projeler } from "../constants/onedio/projeler.js";
import { videolar } from "../constants/onedio/videolar.js";
import { yemekler } from "../constants/onedio/yemekler.js";
import { vitrin } from "../constants/onedio/vitrin.js";
import { programatik } from "../constants/onedio/programatik.js";
import SliderSection from "../components/sections/Slider.jsx";
import { useLanguage } from "../contexts/LanguageContext";

export default function Onedio() {
  const { language } = useLanguage();

  return (
    <div className="flex flex-col">
      <img
        src={
          language === "TR"
            ? "https://srv-cdn.onedio.com/store/9a7adfb53602d4a471332493c6f6fa7c4408ea9dc23dc2dd7830ec51cd240b13.jpeg"
            : "https://srv-cdn.onedio.com/store/a136b1e007facc18eed87a8ff0d9d902015a3fc46c300d500c86982f8b08c204.jpg"
        }
        className="w-full max-w-[1440px] mx-auto"
        alt="Onedio Header Image"
      />
      <DataSection
        data={data}
        title="Datalar"
        titleEN="Data"
        name="datalar"
        socialSlides={socialMediaSlides}
      />
      <SliderSection
        className={"bg-[#FBFBFB]"}
        data={icerikler}
        circle={true}
        name="icerikler"
      />
      <SliderSection
        className={"bg-[#FEF9F3]"}
        data={projeler}
        circle={false}
        name="projeler"
      />
      <SliderSection
        className={"bg-[#F3FCF6]"}
        data={videolar}
        circle={false}
        name="videolar"
      />
      <SliderSection
        className={"bg-[#fdf2f0]"}
        data={yemekler}
        circle={false}
        name="yemekler"
      />
      <SliderSection
        className={"bg-[#ffefdd]"}
        data={vitrin}
        circle={false}
        name="vitrin"
      />
      <SliderSection
        className={"bg-[#f7f7f7]"}
        data={programatik}
        circle={false}
        name="display-programatik"
      />
    </div>
  );
}
